export const FLAGGED_PAGE_SIZE = 10

export function getFlaggedPageCount(totalItems: number, pageSize = FLAGGED_PAGE_SIZE) {
  if (totalItems <= 0) return 0
  return Math.ceil(totalItems / pageSize)
}

export function clampFlaggedPage(
  requestedPage: number,
  totalItems: number,
  pageSize = FLAGGED_PAGE_SIZE,
) {
  const pageCount = getFlaggedPageCount(totalItems, pageSize)
  if (pageCount === 0) return 0
  return Math.min(Math.max(requestedPage, 0), pageCount - 1)
}

export function getPaginatedFlaggedItems<T>(
  items: T[],
  currentPage: number,
  pageSize = FLAGGED_PAGE_SIZE,
) {
  const safePage = clampFlaggedPage(currentPage, items.length, pageSize)
  const start = safePage * pageSize
  return items.slice(start, start + pageSize)
}

export function shouldShowFlaggedPagination(totalItems: number, pageSize = FLAGGED_PAGE_SIZE) {
  return totalItems > pageSize
}

export function buildFlaggedPageNumbers(
  totalPages: number,
  currentPage: number,
): Array<number | 'ellipsis'> {
  const pageNumbers: Array<number | 'ellipsis'> = []

  if (totalPages <= 7) {
    for (let index = 0; index < totalPages; index += 1) {
      pageNumbers.push(index)
    }
    return pageNumbers
  }

  pageNumbers.push(0)
  if (currentPage > 2) pageNumbers.push('ellipsis')

  const start = Math.max(1, currentPage - 1)
  const end = Math.min(totalPages - 2, currentPage + 1)
  for (let index = start; index <= end; index += 1) {
    pageNumbers.push(index)
  }

  if (currentPage < totalPages - 3) pageNumbers.push('ellipsis')
  pageNumbers.push(totalPages - 1)

  return pageNumbers
}
